import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import "colbi_web_ui/lib/style/variableInjector.scss";
import "colbi_web_ui/lib/style/index.sass";
import "mosaic-react/installLicense";

import "./polyfills/object.entries.js";

import React from "react";
import ReactDOM from "react-dom/client";

import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";

import CheckPermissionsRouting from "./components/CheckPermissionsRouting";
import configureStore from "./store";
import { fetchAction } from "./store/actions";
import * as serviceWorker from "./serviceWorker";
import HeadChange from "./components/HeadChange.js";
import { OidcProviderContext } from "./state/oidcProviderContext.js";

export const { store, persistor } = configureStore({});

ReactDOM.createRoot(document.getElementById("root")).render(
    <OidcProviderContext>
        <Provider store={store}>
            <Router>
                <HeadChange />
                <CheckPermissionsRouting store={store} fetchAction={fetchAction} />
            </Router>
        </Provider>
    </OidcProviderContext>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
